import { useEffect, useState } from "react";
import { Coins, Check, Loader2, Shirt } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { ITEM_ICON } from "@/components/PetAvatar";

const SLOT = { kopf: "Kopf", augen: "Augen", hals: "Hals", effekt: "Effekt" };

export function PetShop({ shop, equipped, onEquipped }) {
  const { user, refreshUser } = useAuth();
  const [owned, setOwned] = useState([]);
  const [busy, setBusy] = useState(null);
  useEffect(() => { api.get("/pet/items").then(({ data }) => setOwned(data.owned)); }, []);
  const act = async (it) => {
    setBusy(it.id);
    try {
      if (!owned.includes(it.id)) {
        await api.post(`/pet/items/${it.id}/buy`); setOwned((o) => [...o, it.id]); refreshUser?.();
        toast.success(`${it.name} gekauft und angezogen (−${it.price} Punkte)`);
        onEquipped({ ...equipped, [it.slot]: it.id });
      } else {
        const { data } = await api.post(`/pet/items/${it.id}/equip`); onEquipped(data.equipped);
      }
    } catch (e) { toast.error(formatErr(e)); } finally { setBusy(null); }
  };
  const points = user?.points ?? 0;
  return (
    <div className="bg-white rounded-3xl border border-pink-100 p-5 sm:p-6 space-y-4" data-testid="pet-shop">
      <div><h2 className="font-display text-xl font-extrabold flex items-center gap-2"><Shirt className="w-5 h-5 text-rose-500" /> Zubehör</h2><p className="text-sm text-slate-500">Einmal kaufen, für immer behalten. Pro Bereich (Kopf, Augen, Hals, Effekt) trägt dein Haustier ein Teil.</p></div>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
        {shop.map((it) => {
          const Icon = ITEM_ICON[it.id];
          const has = owned.includes(it.id);
          const on = equipped?.[it.slot] === it.id;
          return (
            <button key={it.id} onClick={() => act(it)} disabled={busy === it.id || (!has && points < it.price)} data-testid={`pet-item-${it.id}`} aria-pressed={on}
              className={`relative rounded-2xl p-3 text-left border transition-[transform,border-color,background-color] active:scale-95 disabled:opacity-50 ${on ? "border-rose-400 bg-rose-50" : it.rare ? "border-amber-300 bg-gradient-to-br from-amber-50 to-white" : "border-pink-100 hover:bg-rose-50/50"}`}>
              {it.rare && <span className="absolute top-2 right-2 text-[9px] font-extrabold tracking-wider text-amber-700 bg-amber-100 rounded-full px-1.5">SELTEN</span>}
              <span className={`w-10 h-10 rounded-xl flex items-center justify-center ${it.rare ? "vip-gold-metal" : "pink-gradient text-white"}`}>{busy === it.id ? <Loader2 className="w-5 h-5 animate-spin" /> : <Icon className="w-5 h-5" />}</span>
              <p className="font-bold text-sm mt-2">{it.name}</p>
              <p className="text-[11px] text-slate-400">{SLOT[it.slot]}</p>
              <p className="text-xs font-bold mt-1" data-testid={`pet-item-state-${it.id}`}>{on ? <span className="text-rose-600 inline-flex items-center gap-1"><Check className="w-3.5 h-3.5" /> Angezogen</span> : has ? <span className="text-slate-500">Anziehen</span> : <span className="text-amber-600 inline-flex items-center gap-1"><Coins className="w-3.5 h-3.5" /> {it.price}</span>}</p>
            </button>
          );
        })}
      </div>
    </div>
  );
}
